import React, { useState } from "react";
import "./Services.css";
const services = [
  {
    title: "Transmission Tower Erection",
    desc: "We provide complete tower erection services with safety and precision."
  },
  {
    title: "HT / LT Line Stringing",
    desc: "High-quality stringing work for HT and LT lines with modern tools."
  },
  {
    title: "Substation Construction",
    desc: "End-to-end substation construction including civil and electrical."
  },
  {
    title: "Survey & Design",
    desc: "Accurate GIS-based survey and optimized transmission design."
  },
  {
    title: "Testing & Commissioning",
    desc: "Reliable testing and commissioning services ensuring performance."
  },
  {
    title: "Maintenance Work",
    desc: "Preventive and corrective maintenance for long-term reliability."
  }
];

const Services = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section className="section light" id="services">
      <h2>Our Services</h2>

      <div className="grid-container">
        {services.map((item, i) => (
          <div className="form-card" key={i} style={{ textAlign: "center" }}>
            
            <div style={{ fontSize: "2rem" }}>⚡</div>
            <h3>{item.title}</h3>

            {/* Know More Button */}
            <button
              className="know-btn"
              onClick={() => setActiveIndex(activeIndex === i ? null : i)}
            >
              {activeIndex === i ? "Hide" : "Know More"}
            </button>

            {/* Expand Content */}
            {activeIndex === i && (
              <p className="service-desc">{item.desc}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;